const listOfCuisines = [
    "American",
    "British",
    "French",
    "Japanese",
    "Italian",
    "Spanish",
    "German",
    "Greek",
    "Mediterranean",
    "Carribean",
    "Mexican",
    "Jamaican",
    "Moroccan",
    "Chinese",
    "Thai",
    "Indian",
    "Korean",
    "Vietnamese",
];

export default listOfCuisines;